"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
var _excluded = ["value", "className", "style", "maxLength"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Textarea = function Textarea(_ref) {
  var value = _ref.value,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? _constants.AUTO_REPLY_MESSAGE_MAX_LENGTH : _ref$maxLength,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTheme = (0, _styles.useTheme)(),
    palette = _useTheme.palette;
  return /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({}, props, {
    value: value,
    maxLength: maxLength,
    className: (0, _classnames["default"])('h-24 px-4 py-2 w-full resize-none text-xs', className),
    style: _objectSpread(_objectSpread({}, palette.type === _constants.themeMode.LIGHT ? {
      boxShadow: 'inset 0 0 0 1px #f0f0f0'
    } : {
      boxShadow: 'none',
      backgroundColor: palette.secondary.main
    }), style)
  }));
};
var _default = exports["default"] = Textarea;
//# sourceMappingURL=Textarea.js.map